import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import InputField from "../../../../generic/inputField";
import TocDropdown from "../../../../generic/tocDropdown";
import { getMergeDocumentBase64 } from "../../../../service/serviceRequest/srApiService";
import { pan, PersonPan } from "../../../../utils/regex";
import { FileUploadSection } from "../../../generic/fileUploadSection";
import { getMaskedAdhar, getQCChecked } from "../../../generic/qCCheck";
import sampleSignature from "../../../../../assets/images/Sample-signature-image.png";
import {
  identificationOptions,
  identityProofOptions,
  idType,
} from "./constant";
import EdModal from "../../../../generic/edModal";

export const IdentifDet = forwardRef((props: any, ref: any) => {
  const [dropDownlownValue, setDropDownValueChanged] = useState<boolean>(false);
  const [frontBack, setFrontBack] = useState<boolean>(false);
  const [selectedProof, setSelectedProof] = useState<any>("");
  // const [viewSampleImage, setViewSampleImage] = useState(false);
  const [identificationDetails, setIdentificationDetails] = useState<any>({
    identity: "",
    identificationText: "",
    photoDocs: {},
    signDocs: {},
    proofOfIdentityDocs: {},
    backProofOfIdentityDocs: {},
  });
  const [personaldetails, setPersonaldetails] = useState<any>({
    pan: "",
    addhar: "",
    bankAcc: "",
    dpId: "",
  });

  const getMaskBase64Data = async function (needMaskObj: any) {
    let maskBase64ForFront: any;
    if (needMaskObj.docType === "Aadhar") {
      let maskObj = {
        proof: needMaskObj.docType,
        accountCode: props.accountCode,
        fileData: needMaskObj.data,
      };
      try {
        maskBase64ForFront = await getMaskedAdhar(maskObj);
      } catch (e) {
        console.log(e);
        maskBase64ForFront = needMaskObj.data;
      }
    } else {
      maskBase64ForFront = needMaskObj.data;
    }
    return maskBase64ForFront ? maskBase64ForFront : needMaskObj.data; //if mask adhar fail right now return original base 64
  };
  const getMergeDocument = async (uploadImageObj: any) => {
    let attachment: any;
    let mergerResp = await getMergeDocumentBase64(uploadImageObj);
    if (mergerResp) {
      let fileArray = [
        "merge_document",
        props.type.id === 1 ? "04" : "05",
        "0" + (props.id + 1),
      ];
      attachment = {
        nm: fileArray.join("_").concat(".pdf"),
        data: mergerResp,
        docType:
          identificationDetails.identity === "Photograph & Signature"
            ? "PhotographAndSignature"
            : selectedProof,
        docCat: identificationDetails.identity,
        qcFlag: false,
      };
      return attachment;
    }
    return false;
  };
  const getAutoQcDetail = async function (checkedObj: any, attachment: any) {
    if (checkedObj.address && checkedObj.fullName && checkedObj.fileData) {
      let resp = await getQCChecked(checkedObj);
      attachment.qcFlag = resp;
    } else {
      attachment.qcFlag = attachment.qcFlag;
    }
  };
  const mergeDocuments = async (identificationDetails: any) => {
    let attachment = {
      nm: "",
      data: "",
      docType: "",
      docCat: "",
      qcFlag: false,
    };
    let uploadImageObj: any;
    if (
      identificationDetails &&
      identificationDetails.proofOfIdentityDocs &&
      identificationDetails.proofOfIdentityDocs.nm &&
      identificationDetails.proofOfIdentityDocs.data
    ) {
      props.setLoader(true);
      await getMaskBase64Data({
        docType: identificationDetails.proofOfIdentityDocs.docType,
        accountCode: props.accountCode,
        data: identificationDetails.proofOfIdentityDocs.data,
      }).then(async (image1Resp) => {
        if (
          identificationDetails.backProofOfIdentityDocs &&
          identificationDetails.backProofOfIdentityDocs.nm &&
          identificationDetails.backProofOfIdentityDocs.data
        ) {
          const image2Resp = await getMaskBase64Data({
            docType: identificationDetails.backProofOfIdentityDocs.docType,
            accountCode: props.accountCode,
            data: identificationDetails.backProofOfIdentityDocs.data,
          });
          if (image2Resp) {
            uploadImageObj = {
              applicationId: props.accountCode,
              image1: image1Resp,
              image2: image2Resp,
              imagename1: identificationDetails.proofOfIdentityDocs.nm,
              imagename2: identificationDetails.backProofOfIdentityDocs.nm,
            };
            attachment = await getMergeDocument(uploadImageObj);
          }
        } else {
          if (image1Resp) {
            attachment = {
              nm: identificationDetails.proofOfIdentityDocs.nm,
              data: image1Resp,
              docType: identificationDetails.proofOfIdentityDocs.docType,
              docCat: identificationDetails.identity,
              qcFlag: false,
            };
          }
        }
      });
    } else if (
      identificationDetails &&
      identificationDetails.photoDocs &&
      identificationDetails.photoDocs.data &&
      identificationDetails.photoDocs.nm &&
      identificationDetails.signDocs &&
      identificationDetails.signDocs.data &&
      identificationDetails.signDocs.nm
    ) {
      props.setLoader(true);
      uploadImageObj = {
        applicationId: props.accountCode,
        image1: identificationDetails.photoDocs.data,
        image2: identificationDetails.signDocs.data,
        imagename1: identificationDetails.photoDocs.nm,
        imagename2: identificationDetails.signDocs.nm,
      };
      attachment = await getMergeDocument(uploadImageObj);
      localStorage.setItem("signature",attachment?.data)
    }
    await getAutoQcDetail(
      {
        addressProof: attachment.docType,
        fileData: attachment.data,
        accountCode: props.accountCode,
        address: props.nominee.address,
        fullName: props.nominee.name,
      },
      attachment
    );

    if (attachment.data != "") {
      props.onChange({ attachment });
    }
    props.setLoader(false);
  };

  const handleSubmitForDocument = (fileDetails: any, type?: any) => {
    setDropDownValueChanged(false);
    let docs: any = [];
    let fileSplitArray = fileDetails.docFile.split("."),
      fileName = [
        fileSplitArray[0],
        props.type.id === 1 ? "04" : "05",
        "0" + (props.id + 1),
      ];
    let fileObj: any;
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      props.setNomineeErr({ ...props.nomineeErr, attachment: "" });
      fileObj = {
        nm: fileName.join("_").concat("." + fileSplitArray[1]),
        data: fileDetails.base64Data.split(",")[1],
        docType:
          identificationDetails.identity === "Photograph & Signature" && type
            ? "PhotographAndSignature"
            : selectedProof,
      };
      // if (
      //   !(identificationDetails.identity === "Photograph & Signature" && type)
      // )
      //   docs.push(fileObj);
    }
    setIdentificationDetails({
      ...identificationDetails,
      [`${type}`]: fileObj ? fileObj : {},
    });
  };
  useEffect(() => {
    console.log(identificationDetails);
    mergeDocuments(identificationDetails);
  }, [identificationDetails]);

  useEffect(() => {
    if (identificationDetails.identity && props.updateIdentity) {
      props.updateIdentity(identificationDetails.identity);
    }
  }, [identificationDetails.identity]);

  function suggestMaxLength() {
    if (identificationDetails.identity === "pan") return 10;
    else if (identificationDetails.identity === "aadhar") return 4;
    else if (identificationDetails.identity === "bankAcc") return 18;
    else if (identificationDetails.identity === "dpId") return 16;
  }
  useImperativeHandle(ref, () => ({
    hasError(value: any) {
      // alert("getAlert from Child");
      return heandelIdentificationValidation(value, true);
    },
  }));

  function heandelIdentificationValidation(value: any, checkOnlyErr?: boolean) {
    let identit = identificationDetails.identity;
    if (identit === "pan") {
      if (!value) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Pan is required",
          });
        if (checkOnlyErr) return "Pan is required";
      } else if (value.length < 10 || !PersonPan.test(value)) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Please enter a valid pan",
          });
        if (checkOnlyErr) return "Please enter a valid pan";
      } else if (value === props.userPan) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identificationDetails.identity]:
              "Account holder's pan and  nominee pan can not be same",
          });
        if (checkOnlyErr)
          return "Account holder's pan and  nominee pan can not be same";
      } else {
        props.setNomineeErr({
          ...props.nomineeErr,
          [identit]: "",
        });
        if (checkOnlyErr) return false;
      }
    } else if (identit === "aadhar") {
      if (!value) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Aadhar is required",
          });
        if (checkOnlyErr) return "Aadhar is required";
      } else if (value.length < 4) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Please enter last 4 digits of aadhar",
          });
        if (checkOnlyErr) return "Please enter last 4 digits of aadhar";
      } else {
        props.setNomineeErr({
          ...props.nomineeErr,
          [identit]: "",
        });
        if (checkOnlyErr) return false;
      }
    } else if (identit === "bankAcc") {
      // let holderDpId = "123456789";
      if (!value) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Bank account is required",
          });
        if (checkOnlyErr) return "Bank account is required";
      } else if (!(value.length >= 8 && value.length <= 18)) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identificationDetails.identity]:
              "Please enter a valid Bank Account No.",
          });
        if (checkOnlyErr) return "Please enter a valid Bank Account No.";
      } else if (value.length < 8) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identificationDetails.identity]:
              "Please enter a correct bank account",
          });
        if (checkOnlyErr) return "Please enter a correct bank account";
      } else {
        props.setNomineeErr({
          ...props.nomineeErr,
          [identit]: "",
        });
        if (checkOnlyErr) return false;
      }
    } else if (identit === "dpId") {
      if (!value) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Demat account is required",
          });
        if (checkOnlyErr) return "Demat account is required";
      } else if (value.length !== 16) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identificationDetails.identity]: "Please enter a valid DpId.",
          });
        if (checkOnlyErr) return "Please enter a valid DpId.";
      } else if (value === personaldetails.dpid) {
        if (!checkOnlyErr)
          props.setNomineeErr({
            ...props.nomineeErr,
            [identit]: "Account holder DpId and Nominee DpId cannot be same.",
          });
        if (checkOnlyErr)
          return "Account holder DpId and Nominee DpId cannot be same.";
      } else {
        props.setNomineeErr({
          ...props.nomineeErr,
          [identit]: "",
        });
        if (checkOnlyErr) return false;
      }
    }
  }

  const getIdentText = (val: string) => {
    return idType.find((ele: any) => {
      if (ele.display == val) return ele;
    })?.value;
  };

  return (
    <>
      <div className="nomineeIdentify">
        <div className="custom--row progressbar_row tradingAccnt">
          <div className="form-field custom-col noLeftPAdding">
            <label className="input-label">
              {props.type.name} Identification Details
            </label>
            <TocDropdown
              selectedValue={identificationDetails.identity}
              dropdownOptions={identificationOptions}
              onSelect={(val: any) => {
                if (val)
                  setIdentificationDetails({
                    ...identificationDetails,
                    identity: val,
                    idTyp: getIdentText(val),
                    photoDocs: {},
                    signDocs: {},
                    proofOfIdentityDocs: {},
                    backProofOfIdentityDocs: {},
                  });
                props.onChange({
                  aadhar: "",
                  bankAcc: "",
                  pan: "",
                  dpId: "",
                  idTyp: getIdentText(val),
                  attachment: {},
                });
                props.setNomineeErr({ ...props.nomineeErr, identity: "" });
                setDropDownValueChanged(true);
              }}
              isSearchable={false}
            />
            {props.nomineeErr.identity !== "" &&
              props.nomineeErr.identity !== undefined && (
                <p className="help_text red">{props.nomineeErr.identity}</p>
              )}
          </div>
          {identificationDetails.identity === "Proof of identity" && (
            <>
              <div className="form-field custom-col noLeftPAdding">
                <label className="input-label">Nominee Proof of Identity</label>
                <TocDropdown
                  selectedValue={selectedProof}
                  dropdownOptions={identityProofOptions}
                  onSelect={(val: any) => {
                    if (val) {
                      setIdentificationDetails({
                        ...identificationDetails,
                        photoDocs: {},
                        signDocs: {},
                        proofOfIdentityDocs: {},
                        backProofOfIdentityDocs: {},
                      });
                      setSelectedProof(val);
                      setDropDownValueChanged(true);
                      setFrontBack(false);
                    }
                  }}
                  isSearchable={false}
                />
                {!selectedProof &&
                  identificationDetails.identity === "Proof of identity" &&
                  props.nomineeErr.attachment && (
                    <p className="help_text red">
                      Please select Proof of Identity
                    </p>
                  )}
              </div>
            </>
          )}

          {identificationDetails.identity !== "Photograph & Signature" &&
            identificationDetails.identity !== "Proof of identity" &&
            identificationDetails.identity && (
              <div className="custom-col">
                <label className="input-label">
                  {
                    identificationOptions.find(
                      (title) => title.value === identificationDetails.identity
                    )?.show
                  }
                </label>
                <InputField
                  pattern={pan}
                  required
                  getValue
                  integer={
                    identificationDetails.identity &&
                    identificationDetails.identity === "pan"
                      ? false
                      : true
                  }
                  maxLength={suggestMaxLength()}
                  onChange={(identificationText: any) => {
                    if (identificationText) {
                      if (
                        identificationDetails.identity &&
                        identificationDetails.identity === "pan"
                      )
                        identificationText = identificationText
                          .toString()
                          .toUpperCase();
                      props.onChange({
                        [`${identificationDetails.identity}`]:
                          identificationText,
                      });
                    }
                  }}
                  onBlur={(error) => {
                    heandelIdentificationValidation(error.value);
                  }}
                  onMouseOut={(val) => {}}
                  placeholder=""
                  errorText={
                    props.nomineeErr &&
                    props.nomineeErr[identificationDetails.identity]
                  }
                  defaultValue={
                    props.nominee &&
                    props.nominee[`${identificationDetails.identity}`]
                      ? props.nominee[`${identificationDetails.identity}`]
                      : ""
                  }
                  autoComplete="off"
                ></InputField>
              </div>
            )}
        </div>
      </div>
      {identificationDetails.identity === "Proof of identity" && selectedProof && (
        <div>
          <div className="custom-row profilePhoto">
            <label className="incomeMsg bold-text">
              {
                identityProofOptions?.find((x) => x.value === selectedProof)
                  ?.display
              }
            </label>
            <p className="ei-text">
              Scanned copy of{" "}
              {
                identityProofOptions?.find((x) => x.value === selectedProof)
                  ?.display
              }{" "}
              Photo
            </p>
            <FileUploadSection
              disableCross={false}
              fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
              onSubmit={(files: any) =>
                handleSubmitForDocument(files, "proofOfIdentityDocs")
              }
              dropValChanged={dropDownlownValue}
              secondFileName={
                frontBack && identificationDetails.backProofOfIdentityDocs
                  ? identificationDetails.backProofOfIdentityDocs?.nm
                  : ""
              }
            />
            {frontBack && (
              <FileUploadSection
                disableCross={false}
                fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                onSubmit={(files: any) =>
                  handleSubmitForDocument(files, "backProofOfIdentityDocs")
                }
                dropValChanged={dropDownlownValue}
                secondFileName={
                  frontBack && identificationDetails.proofOfIdentityDocs
                    ? identificationDetails.proofOfIdentityDocs.nm
                    : ""
                }
              />
            )}

            {(frontBack
              ? !(
                  identificationDetails["proofOfIdentityDocs"] &&
                  identificationDetails["proofOfIdentityDocs"].nm &&
                  identificationDetails["proofOfIdentityDocs"].data &&
                  identificationDetails["backProofOfIdentityDocs"] &&
                  identificationDetails["backProofOfIdentityDocs"].nm &&
                  identificationDetails["backProofOfIdentityDocs"].data
                )
              : !(
                  identificationDetails["proofOfIdentityDocs"] &&
                  identificationDetails["proofOfIdentityDocs"].nm &&
                  identificationDetails["proofOfIdentityDocs"].data
                )) && (
              <p className="text-indicator small--text-indicator noSpaceIndicator">
                Kindly upload clear and coloured images of original documents of
                proof of Identity
              </p>
            )}

            {props.nomineeErr.attachment !== "" &&
              props.nomineeErr.attachment !== undefined && (
                <p className="help_text red">
                  Please Upload Required Document.
                </p>
              )}
          </div>
          <button
            type="button"
            className="ed_button common_button noBg-btn addDocument"
          >
            {frontBack ? (
              <>
                <span className="edel-icon-minus"></span>
                <span
                  onClick={() => {
                    setFrontBack(false);
                    setIdentificationDetails({
                      ...identificationDetails,
                      proofOfIdentityDocs:
                        identificationDetails.proofOfIdentityDocs
                          ? identificationDetails.proofOfIdentityDocs
                          : {},
                      backProofOfIdentityDocs: {},
                    });
                  }}
                >
                  Remove Front/Back Document
                </span>
              </>
            ) : (
              <>
                <span className="edel-icon-plus"></span>
                <span
                  onClick={() => {
                    setFrontBack(true);
                  }}
                >
                  Add Front/Back Document
                </span>
              </>
            )}
          </button>
          <div className="nomineeIdentify">
            <div className="text">
              <p>Upload details of {props.type.name}</p>
            </div>
          </div>
        </div>
      )}

      {identificationDetails.identity === "Photograph & Signature" && (
        <div>
          <div className="custom-row profilePhoto">
            <label className="incomeMsg bold-text">Photograph</label>
            <p className="ei-text">Scanned copy of Passport Size Photo</p>
            <FileUploadSection
              disableCross={false}
              fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
              onSubmit={(files: any) =>
                handleSubmitForDocument(files, "photoDocs")
              }
              dropValChanged={dropDownlownValue}
              secondFileName={
                identificationDetails &&
                identificationDetails["signDocs"] &&
                identificationDetails["signDocs"].nm
                  ? identificationDetails["signDocs"].nm
                  : ""
              }
            />
            {!(
              identificationDetails &&
              identificationDetails["photoDocs"] &&
              identificationDetails["photoDocs"].nm &&
              identificationDetails["photoDocs"].data
            ) && (
              <p className="text-indicator small--text-indicator noSpaceIndicator">
                Kindly upload clear and coloured images of original documents of
                proof of Identity
              </p>
            )}
          </div>
          <div className="custom-row profilePhoto">
            <label className="incomeMsg bold-text">Signature</label>
            <div className="space-between-aligned subLink">
              <p className="ei-text">Photo copy of your Signature</p>
              {!(
                identificationDetails &&
                identificationDetails["signDocs"] &&
                identificationDetails["signDocs"].nm &&
                identificationDetails["signDocs"].data
              ) && (
                <a
                  className="link"
                  onClick={() => props.setViewSampleImage(true)}
                >
                  View Sample
                </a>
              )}
            </div>
            <FileUploadSection
              disableCross={false}
              fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
              onSubmit={(files: any) =>
                handleSubmitForDocument(files, "signDocs")
              }
              dropValChanged={dropDownlownValue}
              secondFileName={
                identificationDetails &&
                identificationDetails["photoDocs"] &&
                identificationDetails["photoDocs"].nm
                  ? identificationDetails["photoDocs"].nm
                  : ""
              }
            />

            {!(
              identificationDetails &&
              identificationDetails["signDocs"] &&
              identificationDetails["signDocs"].nm &&
              identificationDetails["signDocs"].data
            ) && (
              <p className="text-indicator small--text-indicator noSpaceIndicator">
                Kindly upload clear and coloured images of original documents of
                proof of Identity
              </p>
            )}
            {props.nomineeErr.attachment !== "" &&
              props.nomineeErr.attachment !== undefined && (
                <p className="help_text red">
                  Please Upload Required Document.
                </p>
              )}
          </div>
          <div className="nomineeIdentify">
            <div className="text">
              <p>Upload details of {props.type.name}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
});
